<div>
<mat-card>
  <section class="section">
    <div class="container">
      <div class="no-url" *ngIf="src == null">
        {{messageNoAudioAvailable}}
          <ng-content></ng-content>
      </div>
      <app-sia-loading [show]="isAudioQueried && !isLoaded"></app-sia-loading>
      <ng-waveform  data-testid="waveform" #waveform *ngIf="isAudioQueried"
        [src]="src"
        [height]="150"
        [useRegion]="useRegion"
        overlayBackgroundColor ="rgba(0, 0, 0, 0.3)"
        regionBackgroundColor="rgba(255, 255, 255, 0.7)"
        regionStartStickColor="#0a0b09"
        regionEndStickColor="#c6002b"
        regionTextColor="#c6002b"
        [withRegionLabels]="false"
        waveColor="#c6002b"
        (trackLoaded)="onTrackLoaded($event)"
        (rendered)="onTrackRendered($event)"
        (durationChange)="onDurationChange($event)"
        (timeUpdate)="onTimeUpdate($event)"
        (paused)="onPaused()"
        (regionChange)="onRegionChange($event)"
      >
      </ng-waveform> 
      <app-time-bar data-testid="time-bar" *ngIf="isLoaded && tabIndex!=null" [selectedHour]="hour"></app-time-bar>
    </div>
  </section>
  <section class="container container-controls" *ngIf="isLoaded">
    <div class="grid left">
      <header>
        <div class="grid-col"></div>
        <div class="grid-col">Start</div>
        <div class="grid-col"></div>
        <div class="grid-col">End</div>
      </header>
      <div class="grid-row">
        <div class="grid-col selection">
          
        </div>
        <div class="grid-col red">{{ hour }}:{{ start }}
        </div>
        <div class="grid-col text-red">
          {{selectDuration}}
        </div>
        <div class="grid-col red">{{ hour }}:{{ end }}</div>
      </div>
    </div>
    <div class="center">
      <div class="controls">
        <button data-testid="replay" mat-icon-button (click)="replayTenSeconds()">
          <mat-icon>replay_10</mat-icon>
        </button>
        <button data-testid="previous" mat-icon-button (click)="onBackwardButtonClick()">
          <mat-icon>skip_previous</mat-icon>
        </button>
        <button data-testid="play" (click)="onPlayButtonClick()" *ngIf="!play" class="icon-button">
          <mat-icon class="bigger">play_circle</mat-icon>
        </button>
        <button data-testid="stop" (click)="onPauseButtonClick()" *ngIf="play" class="icon-button">
          <mat-icon class="bigger">pause_circle</mat-icon>
        </button>
        <button data-testid="next" mat-icon-button (click)="onForwardButtonClick()">
          <mat-icon>skip_next</mat-icon>
        </button>
        <button data-testid="forward" mat-icon-button (click)="forwardTenSecond()">
          <mat-icon>forward_10</mat-icon>
        </button>
      </div>
      <div class="controls" *ngIf="isLoaded">
        <p class="duration">{{ hour }}:{{ displayCurrentTime }} | {{ hour }}:{{ displayDuration }}</p>
      </div>
    </div>
    <div class="grid right">
      <header>
        <div class="grid-col"></div>
      </header>
      <div class="grid-row">
        <div class="grid-col">
          <button mat-stroked-button data-testid="clear-selection"
            (click)="onClearSelection()" [disabled]="isClearButtonDisabled()">
            Clear
          </button>
        </div>
      </div>
    </div>
  </section>
</mat-card>
<section class="section" *ngIf="isLoaded && isLocal">
  <div class="container">
    <div class="telemetry">
      <h3>Telemetry</h3>
      <p><span class="label">Time to load track:</span><span class="value">{{trackLoadTime}}</span>ms</p>
      <p><span class="label">Time to render wave:</span><span class="value">{{renderingTime}}</span>ms</p>
      <p><span class="label">Duration:</span><span class="value">{{duration | number: '1.2-2'}}</span>s</p>
      <p><span class="label">Current time:</span><span class="value">{{currentTime?.time | number: '1.2-2'}}</span>s</p>
      <p><span class="label">Progress:</span><span class="value">{{currentTime?.progress | number: '1.2-2'}}</span>%</p>
    </div>
    <div class="region-controls">
      <h3>Region control</h3>
      <div class="form-row">
        <label>
          <input type="checkbox" [formControl]="isRegionCtrl">
          Turn region off
        </label>
      </div>
      <ng-container *ngIf="useRegion">
        <label for="region-start">Start</label>
        <input type="number" id="region-start" min="0" [max]="duration" [formControl]="regionStartCtrl">
        <label for="region-end">End</label>
        <input type="number" id="region-end" min="0" [max]="duration" [formControl]="regionEndCtrl">
      </ng-container>
    </div>
  </div>
</section>
</div>